import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'liveDocIconAlt'
	| 'whiteboardIconAlt'
	| 'databaseIconAlt'
	| 'slidesIconAlt'
	| 'pageIconAlt';

export const messages: Record<
	MessageKeys,
	{ id: string; defaultMessage: string; description?: string }
> = defineMessages({
	liveDocIconAlt: {
		id: 'ai-mate.rovo-platform-ui-components.preview-item.live-doc-icon-alt',
		defaultMessage: 'Live Doc Icon',
		description: 'Accessible label for the icon shown next to a live doc preview item.',
	},
	whiteboardIconAlt: {
		id: 'ai-mate.rovo-platform-ui-components.preview-item.whiteboard-icon-alt',
		defaultMessage: 'Whiteboard Icon',
		description: 'Accessible label for the icon shown next to a whiteboard preview item.',
	},
	databaseIconAlt: {
		id: 'ai-mate.rovo-platform-ui-components.preview-item.database-icon-alt',
		defaultMessage: 'Database Icon',
		description: 'Accessible label for the icon shown next to a database preview item.',
	},
	slidesIconAlt: {
		id: 'ai-mate.rovo-platform-ui-components.preview-item.slides-icon-alt',
		defaultMessage: 'Slides Icon',
		description: 'Accessible label for the icon shown next to a slides preview item.',
	},
	pageIconAlt: {
		id: 'ai-mate.rovo-platform-ui-components.preview-item.page-icon-alt',
		defaultMessage: 'Page Icon',
		description: 'Accessible label for the icon shown next to a page preview item.',
	},
});
